import { httpsCallable } from 'firebase/functions';
import { functions as fbFunctions } from './firebaseConfig';

/**
 * Suggest diagnoses with ICD-10 codes.
 * @param {Object} params
 * @param {string} [params.diagnosisText] - initial free-text diagnosis or chief complaint
 * @param {string} [params.notesText] - doctor notes / history / findings
 * @param {number} [params.age]
 * @param {string} [params.gender]
 * @param {number} [params.topK] - max # of suggestions (1..5)
 * @param {string} [params.model] - override model name (default gemini-2.5-flash)
 */
export async function suggestDiagnosisWithICD(params = {}) {
  const callable = httpsCallable(fbFunctions, 'suggestDiagnosisWithICD');
  const res = await callable({ ...params });
  return res?.data || { success: false, suggestions: [] };
}

/**
 * Review existing diagnoses and recommend ICD codes + approval readiness.
 * @param {Object} params
 * @param {string} [params.applicationId]
 * @param {Array} [params.treatments]
 * @param {Object} [params.patient]
 * @param {boolean} [params.fillMissingOnly]
 * @param {string} [params.model]
 */
export async function reviewDiagnosesForApproval(params = {}) {
  const callable = httpsCallable(fbFunctions, 'reviewDiagnosesForApproval');
  const res = await callable({ ...params });
  return res?.data || { success: false, approveRecommended: false, reasons: [], suggestionsById: {} };
}

export default { suggestDiagnosisWithICD, reviewDiagnosesForApproval };
